import * as React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import SignInCarousel from "./carousel";
import BackgroundImage from "./images/background-lighter.png";

const SigninContainer = ({ children }) => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ height: "100vh" }}
    >
      <Grid
        container
        item
        component={Paper}
        xs={12}
        md={10}
        lg={8}
        xl={8}
        variant="signin"
        sx={{ height: 630, maxWidth: "1240px !important", borderRadius: "8px" }}
      >
        <Grid
          item
          xs={false}
          sm={6}
          md={6}
          sx={{
            backgroundColor: "#F6F6FA",
            backgroundImage: `url(${BackgroundImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            paddingTop: "110px",
          }}
        >
          <SignInCarousel />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {children}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SigninContainer;
